import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Col, Row, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  selectActionEvent,
  selectConfig,
  selectConfigActionEvent,
  selectConfigEvent,
  selectMerchantPackageList,
} from 'Store/pos/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { themeConfig } from 'config'
import { LabelItem } from 'Components/form'
import { StatusTag } from 'Components/utilities'
import { ConfirmDailog, LoadingView } from 'Components/modal'
import { GetConfigReq, SetConfigReq } from 'Store/pos/types'
import { getConfigAPI, setConfigAPI } from 'Store/pos/api'
import { clearEventAction } from 'Store/pos/actions'
import { MyTheme } from 'Components/common/Theme'

type Props = {} & ReduxProps

const TerminalConfig: React.FunctionComponent<Props> = props => {
  const { currentUser, actionEvent, event, configData } = props
  const dispatch = useDispatch()
  const [isEnableCashDrawer, setIsEnableCashDrawer] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)

  useEffect(() => {
    onGetConfig()
  }, [])

  useEffect(() => {
    if (configData) {
      const isEnable = configData?.config_value === '1'
      setIsEnableCashDrawer(isEnable)
    }
  }, [configData])

  const onGetConfig = () => {
    const req: GetConfigReq = {
      config: 'ENABLE_CASH_DRAWER',
    }
    dispatch(getConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onUpdateConfig = (val: boolean) => {
    const req: SetConfigReq = {
      config_name: 'ENABLE_CASH_DRAWER',
      config_type: 'int',
      config_value: val ? '1' : '0',
    }
    dispatch(setConfigAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onUpdateSuccess = (): void => {
    clearEvent()
    setShowConfirm(false)
    onGetConfig()
  }

  const ConfirmActivateModal = (
    <ConfirmDailog
      title={'คำเตือนการเปลี่ยนแปลงการใช้งาน'}
      description={
        'เมื่อคุณเปิดใช้งานปุ่มบังคับเปิดรอบการขาย บนเครื่องเทอมินอลจะบังคับให้ทำการเปิดรอบการขายเพื่อทำการบันทึกการขายสินค้าเป็นรอบ/กะ'
      }
      isShow={showConfirm}
      handleOk={() => onUpdateConfig(!isEnableCashDrawer)}
      handleCancel={() => setShowConfirm(false)}
      confirmBtnTxt="ยืนยันการเปลี่ยนแปลง"
    />
  )

  const renderCashdrawerStatus = () => {
    const isActive = isEnableCashDrawer
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => {
                setShowConfirm(true)
              }}
            />
            &nbsp; &nbsp;
            <LabelItem label={'เปิดใช้งานรอบการขาย'} /> &nbsp;
            <StatusTag isPass={isActive} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  return (
    <>
      <Row>
        <Col span={24}>
          <Title>การตั้งค่ารอบการขาย</Title>
          <span>
            เมื่อคุณเปิดใช้งานปุ่มบังคับเปิดรอบการขาย
            บนเครื่องเทอมินอลจะบังคับให้ทำการเปิดรอบการขายเพื่อทำการบันทึกการขายสินค้าเป็นรอบ/กะ
          </span>
        </Col>
        <Col>{renderCashdrawerStatus()}</Col>
      </Row>
      <EventModal
        event={[actionEvent]}
        enable={true}
        successCalback={onUpdateSuccess}
        errorCalback={clearEvent}
      />
      <LoadingView isShow={event.IsLoading} />
      {ConfirmActivateModal}
      {/* {LoadingModal}
      {ConfirmActivateModal} */}
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    actionEvent: selectConfigActionEvent(state),
    event: selectConfigEvent(state),
    configData: selectConfig(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 10px;
`

const SwitchStyled = styled.div`
  margin: 10px 0;
`

export default connect(mapStateToProps)(TerminalConfig)
